import { SectionSummaryAssessmentsEnum } from "src/app/_enums";

export class SectionSummaryAssessment {
    assessmentCategoryId?: number;
    assessmentCategoryName?: string;
    assessmentCategoryNameLatin?: string;
    assessmentId?: number;
    assessmentName?: string;
    assessmentNameLatin?: string;
    sectionSubjectId?: number;
    sectionSubjectsName?: string;
    sectionSubjectNameLatin?: string;
    assessmentSectionSummaryStatus: SectionSummaryAssessmentsEnum;

        
}